import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'

export default function NumberWithText(props) {
  const {number, color, label, symbol} = props
  return (
    <div className="number" data-testid="NumberWithText">
      <div>
        <span className={`large-number ${color}`}>{number}</span>
        <span className={`large-symbol ${color}`}>{symbol}</span>
      </div>
      <span className="item-name">{i18n.t(label)}</span>
    </div>
  )
}

NumberWithText.propTypes = {
  number: PropTypes.number,
  symbol: PropTypes.string,
  label: PropTypes.string,
  color: PropTypes.string,
}
